import { RpcClientService } from "./rpc-client.service";
import * as $ from 'jquery';
import { abort } from '../../assets/js/FDT-EU/abortOTX';

export class Applicationqueue {
    private rpcClientService: RpcClientService;
    constructor(rpcClient: RpcClientService) {
        this.rpcClientService = rpcClient;
    }

    abortOtxApplication() {
        this.rpcClientService.abortApplication();
        abort();
    }

    changeExitButtonState(params: any) {
        // @ts-ignore
        //var closeButton = $(otxModalDialog).parent().find('button.ui-dialog-titlebar-close')
        var closeButton = document.getElementById('ui-dialog-titlebar-close');
       // (params.screenName === 'SimpleProgress' && params.value < 100)? closeButton.hide(): closeButton.show()

    }
}



